export default "__VITE_ASSET__CLytcjAK__"